import { without, equals } from "ramda";
import { create } from "zustand";
import { persist } from "zustand/middleware";

export const useHistoryStore = create(
  persist(
    (set, get) => ({
      history: [],
      selectedTitle: null,

      addToHistory: (title, onDuplicateClick) => {
        const { history } = get();

        if (history.includes(title)) {
          set({ selectedTitle: title });
          if (onDuplicateClick) {
            onDuplicateClick(title);
          }

          return;
        }

        set({
          history: [title, ...without([title], history)],
          selectedTitle: title,
        });
      },
      removeFromHistory: title => {
        const { history, selectedTitle } = get();
        if (history.includes(title)) {
          set({
            history: [...without([title], history)],
            selectedTitle: equals(selectedTitle, title) ? null : selectedTitle,
          });
        }
      },
      clearAllHistory: () => {
        set({
          history: [],
          selectedTitle: null,
        });
      },
    }),
    {
      name: "movie-history-store",
    }
  )
);
